<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">

        <v-dialog v-model="isDialogOpen" max-width="1024" persistent>
          <v-card>
            <v-card-title primary-title class="primary white--text">
              Emitir Notificação
            </v-card-title>

            <v-card-text class="pt-6" v-if="hasMenu">
              <v-row class="mt-0 pt-0">
                <v-col cols="12" class="mb-0 pb-0">
                  <h3 v-if="isLoadingContent">Carregando o painel de configurações das notificações. Aguarde...</h3>
                  <h3 v-else>Configurações de Notificações</h3>
                </v-col>

                <v-col cols="12" v-if="!isLoadingContent">
                  <v-card elevation="2">
                    <v-card-text>
                      <v-row class="px-5">
                        <v-col cols="12" class="py-0 my-0">
                          <span v-if="notificationConfig.selectedUsers.length == usersWithAccessPermission.length">Todos os usuários com permissão receberão notificação.</span>
                          <span v-else-if="notificationConfig.selectedUsers.length == 0">Nenhum usuário foi selecionado.</span>
                          <span v-else>Um total de {{ notificationConfig.selectedUsers.length }} {{ notificationConfig.selectedUsers.length == 1 ? 'usuário receberá': 'usuários receberão'}} notificações.</span>
                        </v-col>

                        <v-col cols="12" md="6">
                          <v-tabs v-model="tab" background-color="transparent" color="basil" grow>
                            <v-tab href="#tab-peoples">Pessoas</v-tab>
                            <v-tab href="#tab-perfils">Perfis</v-tab>
                          </v-tabs>

                          <v-tabs-items v-model="tab">
                            <v-tab-item :value="'tab-peoples'">
                              <v-list max-height="300" class="overflow-y-auto">
                                <v-subheader>Selecione os usuários</v-subheader>

                                <v-list-item-group v-model="notificationConfig.selectedUsers" multiple active-class="" @change="verifyNotificationFields">

                                  <v-list-item v-for="(users, index) in usersWithAccessPermission" :key="index">
                                    <template v-slot:default="{ active }">
                                      <v-list-item-action>
                                        <v-checkbox :input-value="active"></v-checkbox>
                                      </v-list-item-action>

                                      <v-list-item-content>
                                        <v-list-item-title>{{ users.email }}</v-list-item-title>
                                      </v-list-item-content>
                                    </template>
                                  </v-list-item>

                                </v-list-item-group>
                              </v-list>

                              <v-row v-if="usersWithAccessPermission && usersWithAccessPermission.length > 0">
                                <v-col>
                                  <v-checkbox v-model="isCheckedAllUsers" dense label="Selecionar todos os usuários" @change="selectAllUsers()"></v-checkbox>
                                </v-col>
                              </v-row>
                            </v-tab-item>

                            <v-tab-item :value="'tab-perfils'">
                              <v-list max-height="300" class="px-2 overflow-y-auto">
                                <v-subheader>Selecione os perfis</v-subheader>

                                <v-list-item-group v-model="notificationConfig.selectedProfiles" multiple active-class="" @change="verifyNotificationFields">

                                  <v-list-item v-for="(profile, index) in profiles" :key="index">
                                    <template v-slot:default="{ active }">
                                      <v-list-item-action>
                                        <v-checkbox :input-value="active"></v-checkbox>
                                      </v-list-item-action>

                                      <v-list-item-content>
                                        <v-list-item-title>{{ profile.name }}</v-list-item-title>
                                      </v-list-item-content>
                                    </template>
                                  </v-list-item>

                                </v-list-item-group>
                              </v-list>

                              <v-row v-if="profiles && profiles.length > 0">
                                <v-col>
                                  <v-checkbox v-model="isCheckedAllProfiles" dense label="Selecionar todos os perfis" @change="selectAllProfiles()"></v-checkbox>
                                </v-col>
                              </v-row>
                            </v-tab-item>
                          </v-tabs-items>
                        </v-col>

                        <v-col cols="12" md="6">
                          <v-row>
                            <v-col cols="12" md="6" class="pb-0 mb-0">
                              <header class="py-0 my-0">Template Padrão</header>
                              <v-select :no-data-text="noDataAvailable" placeholder="Selecione um template" :items="driveDefaultTemplates"
                                        item-text="description" item-value="id" v-model="notificationConfig.driveDefaultTemplateId"
                                        @change="verifyNotificationFields">
                              </v-select>
                            </v-col>
                            <v-col cols="12" md="6" class="pb-0 mb-0">
                              <header class="py-0 my-0">Template de E-mail</header>
                              <v-select :no-data-text="noDataAvailable" placeholder="Selecione um template" :items="driveEmailTemplates"
                                        item-text="description" item-value="id" v-model="notificationConfig.driveEmailTemplateId"
                                        @change="verifyNotificationFields">
                              </v-select>
                            </v-col>

                            <v-col cols="12" class="pb-0 mb-0">
                              <header class="py-0 my-0">Tipos de Notificações</header>
                              <v-select :no-data-text="noDataAvailable" v-model="notificationConfig.deliveryChannels" :items="deliveryChannels"
                                        attach chips placeholder="Selecione os tipos de notificações" multiple
                                        @change="verifyNotificationFields">
                              </v-select>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>

                    </v-card-text>
                  </v-card>
                </v-col>

                <v-row v-if="!isLoadingContent">
                  <flash-message></flash-message>
                </v-row>

                <v-col cols="12">
                  <v-overlay :value="isLoadingContent" :opacity="0">
                    <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
                  </v-overlay>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-text v-else>
              <v-row class="px-5">
                <v-col cols="12" md="6">
                  <v-row>
                    <v-col cols="12">
                      <v-text-field label="E-mails dos Usuários" v-model="notificationConfig.customEmails" autofocus
                                    @input="verifyNotificationFields"></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12" md="6">
                  <v-row>
                    <v-col cols="12" class="pb-0 mb-0">
                      <header class="py-0 my-0">Tipos de Notificações</header>
                      <v-select :no-data-text="noDataAvailable" v-model="notificationConfig.deliveryChannels" :items="deliveryChannelsSalesforce"
                                attach chips placeholder="Selecione os tipos de notificações" multiple
                                @change="verifyNotificationFields"></v-select>
                    </v-col>

                    <v-col cols="12" class="pb-0 mb-0">
                      <header class="py-0 my-0">Template Padrão</header>
                      <v-select :no-data-text="noDataAvailable" placeholder="Selecione um template" :items="driveDefaultTemplates"
                                item-text="description" item-value="id" v-model="notificationConfig.driveDefaultTemplateId"
                                @change="verifyNotificationFields">
                      </v-select>
                    </v-col>

                    <v-col cols="12" class="pb-0 mb-0">
                      <header class="py-0 my-0">Template de E-mail</header>
                      <v-select :no-data-text="noDataAvailable" placeholder="Selecione um template" :items="driveEmailTemplates"
                                item-text="description" item-value="id" v-model="notificationConfig.driveEmailTemplateId"
                                @change="verifyNotificationFields"></v-select>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>

            <v-divider/>

            <v-card-actions class="px-4 pb-2">
              <v-spacer/>
              <v-btn depressed class="primary" :disabled="!isNotificationConfigValid" @click="sendNotification">Enviar</v-btn>
              <v-btn depressed class="tertiary" @click="close()">Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { findAllDriveDefaultTemplates, findAllDriveEmailTemplates, findAllProfilesByAppCode } from '@/common/securityserver';
import { getAllUsersWithAccessPermissionByFinancialGroup } from '@/common/driveserver';
import store from '../../common/store';

export default {
  name: 'ConfigureNotification',
  data: () => ({
    hasMenu: false,
    isOpen: false,
    creationConfirmed: false,
    driveDefaultTemplates: [],
    driveEmailTemplates: [],
    indexesHistory: [],
    isCheckedAllProfiles: false,
    isCheckedAllUsers: true,
    isLoadingContent: false,
    isNotificationConfigValid: false,
    itemParams: null,
    notificationConfig: {
      title: 'Notificação do Drive',
      customEmails: '',
      deliveryChannels: null,
      driveDefaultTemplateId: null,
      driveEmailTemplateId: null,
      isSalesforceConfig: false,
      userIds: null,
      profileIds: null,
      selectedProfiles: [],
      selectedUsers: [],
      pathFileDir: null,
    },
    profiles: [],
    deliveryChannels: [
      { text: 'Notificação Padrão', value: 'DEFAULT_NOTIFICATION' },
      { text: 'Notificação via E-mail', value: 'EMAIL_NOTIFICATION' },
      { text: 'Notificação Push', value: 'PUSH_NOTIFICATION' },
    ],
    deliveryChannelsSalesforce: [
      { text: 'Notificação Padrão', value: 'DEFAULT_NOTIFICATION' },
      { text: 'Notificação via E-mail', value: 'EMAIL_NOTIFICATION' },
    ],
    usersWithAccessPermission: [],
    tab: '',
    noDataAvailable: 'Nenhum dado encontrado',
  }),
  props: {
    isDialogOpen: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  watch: {
    isDialogOpen(newValue) {
      if (newValue && !this.isLoadingContent) {
        this.loadAllInformations();
      }
    },
  },
  methods: {
    sendNotification() {
      this.loadUserIdsSelectedsToNotify();
      this.loadProfileIdsSelectedsToNotify();
      this.$emit('sendNotificationByDialog', this.notificationConfig);
    },
    close() {
      this.clearNotificationFields();
      this.$emit('closeManuallyNotificationDialog');
    },
    clearNotificationFields() {
      this.notificationConfig.title = 'Notificação do Drive';
      this.notificationConfig.deliveryChannels = null;
      this.notificationConfig.driveDefaultTemplateId = null;
      this.notificationConfig.driveEmailTemplateId = null;
      this.notificationConfig.userIds = null;
      this.notificationConfig.profileIds = null;
      this.notificationConfig.selectedProfiles = [];
      this.notificationConfig.selectedUsers = [];
      this.profiles = [];
      this.usersWithAccessPermission = [];
    },
    loadPathDir() {
      const indexesHistory = store.getIndexesHistory();
      if (indexesHistory) {
        this.notificationConfig.pathFileDir = indexesHistory[indexesHistory.length - 1].path;
      }
    },
    verifyNotificationFields() {
      this.loadPathDir();
      if (!this.isEmptyNotificationFields(this.notificationConfig)) {
        this.isNotificationConfigValid = true;
      } else {
        this.isNotificationConfigValid = false;
      }
    },
    isEmptyNotificationFields(notificationConfig) {
      const emptyFields = [];
      if (this.hasMenu && notificationConfig.driveDefaultTemplateId === null) {
        emptyFields.push('Template Padrão');
      }
      if (notificationConfig.driveEmailTemplateId === null) {
        emptyFields.push('Template de E-mail');
      }
      if (this.hasMenu && (!notificationConfig.selectedUsers || (notificationConfig.selectedUsers && notificationConfig.selectedUsers.length === 0
        && (!notificationConfig.selectedProfiles || (notificationConfig.selectedProfiles && notificationConfig.selectedProfiles.length === 0))))) {
        emptyFields.push('Usuários');
      }
      if (!this.hasMenu && this.notificationConfig.customEmails.trim().length === 0) {
        emptyFields.push('E-mails dos Usuários');
      }
      if (!notificationConfig.deliveryChannels || (notificationConfig.deliveryChannels && notificationConfig.deliveryChannels.length === 0)) {
        emptyFields.push('Tipos de Notificações');
      }

      if (emptyFields.length > 0) {
        return true;
      }
      return false;
    },
    async loadDriveDefaultTemplates() {
      await findAllDriveDefaultTemplates(store.getToken())
        .then((response) => {
          if (response.data && response.data.length > 0) {
            this.driveDefaultTemplates = response.data;
          }
        })
        .catch(() => {
          this.flash('Ocorreu um erro ao carregar os templates default do drive.', 'error', { timeout: 5000 });
        });
    },
    async loadDriveEmailTemplates() {
      await findAllDriveEmailTemplates(store.getToken())
        .then((response) => {
          if (response.data && response.data.length > 0) {
            this.driveEmailTemplates = response.data;
          }
        })
        .catch(() => {
          this.flash('Ocorreu um erro ao carregar os templates email do drive.', 'error', { timeout: 5000 });
        });
    },
    async loadAllProfiles() {
      await findAllProfilesByAppCode(store.getToken())
        .then((response) => {
          if (response.data && response.data.length) {
            this.profiles = response.data;
          }
        })
        .catch(() => {
          this.flash('Ocorreu um erro ao carregar os perfis de usuário.', 'error', { timeout: 5000 });
        });
    },
    async loadUsersWithAccessPermissionByFinancialGroup() {
      const path = this.itemParams && this.itemParams.path ? this.itemParams.path : '';

      await getAllUsersWithAccessPermissionByFinancialGroup(path, store.getToken())
        .then((response) => {
          if (response.data && response.data.length > 0) {
            this.usersWithAccessPermission = response.data;
          }
        })
        .catch(() => {
          this.flash('Ocorreu um erro ao carregar os usuários a serem notificados.', 'error', { timeout: 5000 });
        });
    },
    enableAllUsersToNotification() {
      const usersLength = this.usersWithAccessPermission.length;
      for (let count = 0; count < usersLength; count += 1) {
        this.notificationConfig.selectedUsers.push(count);
      }
      this.isCheckedAllUsers = true;
    },
    selectAllProfiles() {
      if (this.isCheckedAllProfiles) {
        this.notificationConfig.selectedProfiles = [];
        this.notificationConfig.selectedProfiles = Array.from(Array(this.profiles.length).keys());
      } else {
        this.notificationConfig.selectedProfiles = [];
      }
      this.verifyNotificationFields();
    },
    selectAllUsers() {
      if (this.isCheckedAllUsers) {
        this.notificationConfig.selectedUsers = [];
        this.notificationConfig.selectedUsers = Array.from(Array(this.usersWithAccessPermission.length).keys());
      } else {
        this.notificationConfig.selectedUsers = [];
      }
      this.verifyNotificationFields();
    },
    loadUserIdsSelectedsToNotify() {
      const usersFiltered = [];
      this.notificationConfig.selectedUsers.forEach((value) => {
        usersFiltered.push(this.usersWithAccessPermission[value].userId);
      });
      this.notificationConfig.selectedUsers = usersFiltered;
    },
    loadProfileIdsSelectedsToNotify() {
      const profilesFiltered = [];
      this.notificationConfig.selectedProfiles.forEach((value) => {
        profilesFiltered.push(this.profiles[value].id);
      });
      this.notificationConfig.selectedProfiles = profilesFiltered;
    },
    verifyHasMenuAndLoadInformations() {
      this.hasMenu = store.getHasMenu();
      this.notificationConfig.isSalesforceConfig = !this.hasMenu;
    },
    async loadAllInformations() {
      this.isLoadingContent = true;
      this.verifyHasMenuAndLoadInformations();
      this.loadPathDir();
      await this.loadDriveEmailTemplates();
      await this.loadDriveDefaultTemplates();

      if (this.hasMenu) {
        await this.loadAllProfiles();
        await this.loadUsersWithAccessPermissionByFinancialGroup();
        this.enableAllUsersToNotification();
      }

      this.isLoadingContent = false;
    },
  },
  async created() {
    await this.loadAllInformations();
  },
};
</script>

<style scoped>

</style>
